/* eslint-disable max-len */

export default function CircleIcon() {
    return (
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <path d="M42,24c0,9.941-8.059,18-18,18S6,33.941,6,24,14.059,6,24,6s18,8.059,18,18Z" fill="#D9D9D9" />
        </svg>
    );
}
